<template>
  <div>
    <p>
      <span class="txt">城市</span>
      <el-input
        v-model="city"
        size="small"
        placeholder="请输入内容"
        style="width: 180px; margin-right: 20px"
      />

      <el-button
        size="mini"
        type="primary"
        icon="el-icon-search"
        @click="searchBtn"
        >查询</el-button
      >
      <el-button
        size="mini"
        type="success"
        icon="el-icon-plus"
        @click="dialogFormVisible = true"
        >新增</el-button
      >
    </p>
    <el-table
      :data="tableData"
      :header-cell-style="{ background: '#41A1FF', color: '#fff' }"
      style="width: 100%"
      size="small"
      border
    >
      <el-table-column align="center" prop="city" label="城市" />
      <el-table-column align="center" prop="address" label="地址" />
      <el-table-column align="center" prop="name" label="创建人" />
      <el-table-column align="center" fixed="right" label="操作" width="150">
        <template slot-scope="scope">
          <el-button type="success" size="mini" @click="editBtn(scope.row)"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div style="margin-top: 10px; text-align: center">
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="page_size"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <el-dialog :visible.sync="dialogFormVisible" title="新增城市">
      <el-form ref="addForm" :model="addForm" :rules="rules">
        <el-form-item :label-width="formLabelWidth" label="城市" prop="city">
          <el-input
            v-model="addForm.city"
            clearable
            type="text"
            placeholder="请输入"
          />
        </el-form-item>

        <el-form-item :label-width="formLabelWidth" label="地址" prop="address">
          <el-input
            :rows="2"
            v-model="addForm.address"
            type="textarea"
            autocomplete="off"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogFormVisible = false"
          >取消</el-button
        >
        <el-button size="small" type="primary" @click="submitAdd('addForm')"
          >提交</el-button
        >
      </div>
    </el-dialog>
    <el-dialog :visible.sync="editFormVisible" title="编辑城市">
      <el-form ref="editForm" :model="editForm" :rules="rules">
        <el-form-item :label-width="formLabelWidth" label="城市" prop="city">
          <el-input
            v-model="editForm.city"
            clearable
            type="text"
            placeholder="请输入"
          />
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" label="地址" prop="address">
          <el-input
            :rows="2"
            v-model="editForm.address"
            type="textarea"
            autocomplete="off"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editFormVisible = false"
          >取消</el-button
        >
        <el-button size="small" type="primary" @click="submitEdit"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { searchAddress, addAddress, editAddress } from '@/api/city'
// import { regionData  } from 'element-china-area-data';//省市
export default {
  data() {
    return {
      city: '',
      total: 0,
      page: 1,
      page_size: 20,
      tableData: [],
      dialogFormVisible: false,
      editFormVisible: false,
      addForm: {
        city: '',
        address: ''
      },
      editForm: {
        id: '',
        city: '',
        address: ''
      },
      formLabelWidth: '120px',
      rules: {
        city: [{ required: true, message: '请选择地址', trigger: 'blur' }],
        address: [{ required: true, message: '请选择地址', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.searchSubmit({ city: '' })
  },
  methods: {
    searchBtn() {
      const data = {
        city: this.city,
        page: 1
      }
      this.searchSubmit(data)
    },
    // 搜索列表
    searchSubmit(params) {
      searchAddress(params)
        .then((response2) => {
          const responseData = response2.data.address
          if (responseData) {
            this.tableData = responseData
            this.total = response2.data.pagination.total
          } else {
            this.tableData = []
            this.total = 0
          }
        })
        .catch(() => {})
    },

    // 提交新增
    submitAdd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          addAddress(this.addForm)
            .then((response1) => {
              if (response1.code === 'success') {
                this.successMsg()
                this.dialogFormVisible = false
                this.searchSubmit({ city: this.city })
              } else {
                this.errMsg()
              }
            })
            .catch()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 编辑点击
    editBtn(row) {
      this.editForm.id = row.id
      this.editForm.city = row.city
      this.editForm.address = row.address
      this.editFormVisible = true
    },
    // 提交修改
    submitEdit() {
      editAddress(this.editForm)
        .then((response3) => {
          if (response3.code === 'success') {
            this.successMsg()
            this.editFormVisible = false
            this.searchSubmit({ city: this.city })
          } else {
            this.errMsg()
          }
        })
        .catch()
    },
    successMsg() {
      this.$message({
        message: '操作成功',
        type: 'success'
      })
    },
    errMsg() {
      this.$message({
        message: '操作失败',
        type: 'error'
      })
    },
    // 翻页
    handleSizeChange(val) {
      this.page_size = val
      const data = {
        city: this.city,
        page_size: val,
        page: 1
      }
      this.searchSubmit(data)
    },
    handleCurrentChange(val) {
      this.page = val
      const data = {
        page: val,
        city: this.city,
        page_size: this.page_size
      }
      this.searchSubmit(data)
    }
    // 删除
    // deleteRow(rowData) {
    //   this.$confirm('是否删除?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   })
    //     .then(() => {
    //       const params = {
    //         type: 2,
    //         config_id: rowData.config_id
    //       }
    //       commonSystem(params)
    //         .then(response => {
    //           this.$message({
    //             message: '删除成功',
    //             type: 'success'
    //           })
    //           this.getUserinfo()
    //         })
    //         .catch(error => {
    //           console.log(error)
    //         })
    //     })
    //     .catch(() => {
    //       this.$message({
    //         type: 'info',
    //         message: '已取消删除'
    //       })
    //     })
    // }
  }
}
</script>
<style scope>
.txt {
  text-align: right;
  vertical-align: middle;
  font-weight: 700;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  padding: 0 12px 0 0;
  box-sizing: border-box;
}
</style>
